define('modules/page_listing/views/main',['require','exports','module','base/collectionview','backbone','./listing_item','../models/page_update','./empty_view','common/views/alert_view','lib/util','env','lodash','services/auth/trial','./create_page_popup','common/views/confirmation_popup','./add_tag_popup','../models/tag','../collections/tags','common/views/trial_expiration_popup','./copy_integrations_popup','./copy_to_account_popup','common/views/loading_view','ldsh!../templates/main'],function (require, exports, module) {
  'use strict';

  var CollectionView = require('base/collectionview'),
    Backbone = require('backbone'),
    PageListingItemView = require('./listing_item'),
    PageUpdateModel = require('../models/page_update'),
    PageListingEmptyView = require('./empty_view'),
    AlertView = require('common/views/alert_view'),
    util = require('lib/util'),
    config = require('env'),
    _ = require('lodash'),
    AuthTrial = require('services/auth/trial'),
    authTrial = new AuthTrial(),
    CreatePagePopupView = require('./create_page_popup'),
    ConfirmationPopup = require('common/views/confirmation_popup'),
    AddTagPopup = require('./add_tag_popup'),
    Tag = require('../models/tag'),
    Tags = require('../collections/tags'),
    TrialExpirationPopup = require('common/views/trial_expiration_popup'),
    CopyIntegrationsPopup = require('./copy_integrations_popup'),
    CopyToAccountPopup = require('./copy_to_account_popup'),
    LoadingView = require('common/views/loading_view');

  var Controller = {
    newPage: function (platform) {
      new CreatePagePopupView({ platform: platform, collection: this.collection });
    },

    duplicatePage: function (itemView, nop, page) {
      var options = { includeIntegrations: true };
      CopyIntegrationsPopup.show(page)
        .fail(function () {
          options.includeIntegrations = false;
        })
        .always(
          _.bind(function () {
            this.collection.duplicatePage(page, options, _.bind(this._notifyDuplicated, this));
          }, this)
        );
    },

    deletePage: function (itemView, nop, page) {
      var listView = this;

      if (config.avoidConfirmMessages) {
        return page.destroy().then(_.bind(listView._notifyDeleted, listView));
      }

      ConfirmationPopup.show({
        title: $.i18n.t('pageListing.dialog.delete.title'),
        message: $.i18n.t('pageListing.dialog.delete.confirm').replace('{0}', page.get('name')),
      }).then(function () {
        page.destroy().then(_.bind(listView._notifyDeleted, listView));
      });
    },

    publish: function (itemView, nop, page) {
      if (authTrial.hasExpired()) return this._displayTrialNotification();
      page.publish({
        success: _.bind(this._notifyPublished, this),
        error: _.bind(this._notifyError, this),
      });
    },

    updatePage: function (itemView, nop, page) {
      var updateCommand = new PageUpdateModel({}, { pageId: page.id });
      updateCommand
        .save(
          {},
          {
            success: _.bind(this._notifyUpdated, this),
            error: _.bind(this._notifyError, this),
          }
        )
        .done(function () {
          page.fetch();
        });
    },

    unPublish: function (itemView, nop, page) {
      page.unPublish({
        success: _.bind(this._notifyUnpublished, this),
        error: _.bind(this._notifyError, this),
      });
    },

    showInfo: function (itemView, nop, page) {
      Backbone.history.navigate('/info/' + page.id, { trigger: true });
    },

    showIntegration: function (itemView, nop, page) {
      Backbone.history.navigate('/integration/' + page.id, { trigger: true });
    },

    addTag: function (itemView, nop, page) {
      AddTagPopup.show(page).then(_.bind(this.reloadTags, this));
    },

    reloadTags: function () {
      this.tags.fetch();
    },

    copyToAccount: function (itemView, nop, page) {
      CopyToAccountPopup.show().then(
        _.bind(function (companyId) {
          this.collection.duplicatePage(
            page,
            { companyId: companyId },
            _.bind(this._notifyDuplicated, this)
          );
        }, this)
      );
    },

    toggleVisibility: function (itemView, nop, page) {
      page.toggleVisibility({
        success: _.bind(this._notifyHidden, this),
        error: _.bind(this._notifyError, this),
      });
    },

    _addTagToPage: function (page, name) {
      var tag = new Tag({ text: name });
      tag.url = page.getTagUrl();
      tag.save({
        success: _.bind(this._notifyUpdated, this),
        error: _.bind(this._notifyError, this),
      });
    },

    _displayTrialNotification: function () {
      TrialExpirationPopup.show();
    },

    displayNotification: function (text, isSuccess) {
      AlertView.showAlert({
        alertType: isSuccess ? 'success' : 'danger',
        message: text,
      });
    },

    _notifyCreated: function () {
      this.displayNotification(this.ui.landingCreated, true);
    },

    _notifyPublished: function () {
      this.displayNotification(this.ui.landingPublished, true);
    },

    _notifyUpdated: function () {
      this.displayNotification(this.ui.landingUpdated, true);
    },

    _notifyUnpublished: function () {
      this.displayNotification(this.ui.landingUnpublished, true);
    },

    _notifyError: function () {
      this.displayNotification(this.ui.landingError, false);
    },

    _notifyDeleted: function () {
      this.displayNotification(this.ui.landingDeleted, true);
    },

    _notifyDuplicated: function () {
      this.displayNotification(this.ui.landingDuplicated, true);
      window.scrollTo(0, 0);
    },

    _notifyHidden: function () {
      this.displayNotification(this.ui.landingHidden, true);
    },

    _loadTranslations: function () {
      if (this._ui) {
        return;
      }
      //save a copy
      this._ui = this.ui || [];
      this.ui = {};
      _.each(
        this._ui,
        function (key) {
          var res = $.i18n.t('pageListing.notifications.' + key);
          this.ui[key] = res;
        },
        this
      );
    },
  };

  module.exports = CollectionView.extend({
    ui: [
      'landingCreated',
      'landingError',
      'landingDeleted',
      'landingPublished',
      'landingUpdated',
      'landingUnpublished',
      'landingDuplicated',
      'landingHidden',
    ],

    initialize: function (options) {
      this.loadingAlertView = null;
      this.hasToFilterAndSort = true;
      this.filteredCollection = [];
      this.viewModel = options.filters;
      this.listenTo(this.childVent, 'page:delete', this.deletePage);
      this.listenTo(this.childVent, 'page:publish', this.publish);
      this.listenTo(this.childVent, 'page:update', this.updatePage);
      this.listenTo(this.childVent, 'page:unpublish', this.unPublish);
      this.listenTo(this.childVent, 'page:duplicate', this.duplicatePage);
      this.listenTo(this.childVent, 'navigate:info', this.showInfo);
      this.listenTo(this.childVent, 'navigate:integration', this.showIntegration);
      this.listenTo(this.childVent, 'tag:add', this.addTag);
      this.listenTo(this.childVent, 'tag:reload', this.reloadTags);
      this.listenTo(this.childVent, 'page:copy', this.copyToAccount);
      this.listenTo(this.childVent, 'page:hide page:display', this.toggleVisibility);
      this.listenTo(
        this.childVent,
        'page:hide page:display',
        _.bind(function () {
          this.render();
        }, this)
      );
      this.listenTo(
        this.viewModel,
        'change:sortBy change:filterBy change:showHidden',
        _.bind(function () {
          this.renderWithSpinner();
        }, this)
      );
      this.listenTo(
        this.childVent,
        'page:delete page:publish page:unpublish page:duplicate page:copy',
        _.bind(function () {
          this.render();
        }, this)
      );
      this.listenTo(this.viewModel, 'end:of:list', this.showEndOfListMessage);
      this.listenTo(this.viewModel, 'reset:order', this.resetOrder);
      this.listenTo(this.viewModel, 'reset:hidden', this.resetHidden);
      this.listenTo(this.viewModel, 'reset:published', this.resetPublished);

      this._loadTranslations();
      this.tags = options.tags || new Tags();

      this.throttledLoad = _.throttle(this.loadMore.bind(this), 500);
      this.attachScrollListener();
    },

    bodyClasses: ['landingPagesGenerator', 'home'],

    template: require('ldsh!../templates/main'),

    itemView: PageListingItemView,

    emptyViewType: PageListingEmptyView,

    collectionIterator: function (collection, fn, ctx) {
      collection.forEach(fn, ctx);
    },
    enableFilters: function (enable) {
      this.viewModel.set({
        disabledFilters: enable,
      });
    },
    attachScrollListener: function () {
      $(window).on('scroll', this.throttledLoad);
      this.loadingAlertView && this.loadingAlertView.hide();
    },
    deAttachScrollListener: function () {
      $(window).off('scroll', this.throttledLoad);
    },
    render: function () {
      this.viewModel.set({
        totalItemCount: this.collection.totalItemCount,
      });

      if ((this.collection || []).length == 0) {
        this.filteredCollection = [];
      }
      if ((this.collection || []).length != 0 && this.hasToFilterAndSort) {
        this.filteredCollection = this.viewModel.filterAndSort(this.collection);
        this.hasToFilterAndSort = false;
      }
      return module.exports.__super__.render.call(this, this.filteredCollection);
    },

    onRender: function () {
      this.$el.i18n();
    },

    renderWithSpinner: function () {
      this.$el.empty().append(new LoadingView().render().$el);
      this.viewModel.resetPointer();
      this.attachScrollListener();
      this.hasToFilterAndSort = true;
      return this.render();
    },
    loadMore: function () {
      var scrollPosition = $(window).scrollTop() + $(window).height();
      var triggerPoint = $(document).height() - 200;

      if (scrollPosition >= triggerPoint) {
        this.hasToFilterAndSort = true;
        this.render();
      }
    },

    showEndOfListMessage: function () {
      this.showLoading();
      this.deAttachScrollListener();
      var self = this;
      this.collection.fetchNextPage({
        success: function () {
          self.hasToFilterAndSort = true;
          self.showAlertIfNeededListenerScroll(
            self.collection.totalItemCount,
            self.collection.length
          );
          self.enableFilters(false);
          self.render();
        },
        error: function () {
          console.log('Errr');
        },
        callback: function (totalItemCount, length) {
          self.showAlertIfNeededListenerScroll(totalItemCount, length);
          self.enableFilters(false);
        },
      });
    },

    showLoading: function () {
      this.enableFilters(true);
      this.loadingAlertView = AlertView.showAlert({
        alertType: 'info',
        autoHide: false,
        persist: true,
        message: $.i18n.t('common.loadingText'),
      });
    },

    showAlertIfNeededListenerScroll: function (collectionTotalItemCount, collectionLength) {
      if (collectionTotalItemCount <= collectionLength) {
        AlertView.showAlert({
          alertType: 'success',
          message: $.i18n.t('pageListing.endItems'),
        });
        this.loadingAlertView && this.loadingAlertView.hide();
        return this.deAttachScrollListener();
      }
      this.attachScrollListener();
    },

    resetOrder: function (sortBy) {
      this.showLoading();
      this.deAttachScrollListener();
      var self = this;
      this.collection.fetchForSort(
        {
          success: function () {
            self.fetchSuccessAction();
          },
          error: function () {
            console.log('Errr');
          },
        },
        sortBy
      );
    },
    resetHidden: function (hidden) {
      this.showLoading();
      this.deAttachScrollListener();
      var self = this;
      this.collection.fetchForHidden(
        {
          success: function () {
            self.fetchSuccessAction();
          },
          error: function () {
            console.log('Errr');
          },
        },
        hidden
      );
    },
    resetPublished: function (published) {
      this.showLoading();
      this.deAttachScrollListener();
      var self = this;
      this.collection.fetchForPublished(
        {
          success: function () {
            self.fetchSuccessAction();
          },
          error: function () {
            console.log('Errr');
          },
        },
        published
      );
    },

    fetchSuccessAction: function () {
      this.hasToFilterAndSort = true;
      this.attachScrollListener();
      this.enableFilters(false);
      this.render();
    },
  });

  util.mixin(module.exports, Controller);
});

